/**
 * This is the main module of the application and defines the global dependencies,
 * sets up application-wide client-side features and functionality (such as the PJAX
 * implementation, the spinner.etc.) and also setups the required routing.
 */

require('babel-polyfill');
require('./lib/jquery/security.js');
require('./lib/jquery/jquery-contains.js');
require('./vendor/pjax/jquery.pjax.js');
require('./lib/select2.js');
require('./vendor/underscore/underscore.js');
require('./vendor/colpick/colpick.js');
require('bootstrap');
require('./vendor/intl-numbers/intlTelInput.js');
require('./lib/filtertron/filtertron.js');
require('./lib/filtertron/filtertron-tray.js');
require('./lib/clarify.js');
require('./lib/moment.js');

var $ = require('jQuery');

var pjax = require('pjax');
var tabular = require('tabular');
var token = $('input[name=_token]').val();

var Vue = require('vue');
var PortalVue = require('portal-vue');
var Vuex = require('vuex');

Vue.use(PortalVue);
Vue.use(Vuex);

// Axios setup
import axios from 'axios'
Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.prototype.$http.defaults.headers.common['X-CSRF-TOKEN'] = token;

$(document).ready(function() {
  // Seed CSRF Token on initial load (if it's on the page).
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': token
    }
  });

  require('./lib/markdown-editor.js');
  require('./lib/pjax.js');
  require('./lib/main-menu.js');
  require('./lib/redirector.js');
  require('./lib/status-widget.js');
  require('./lib/tooltip.js');
  require('./common/account-switcher.js');
  require('./common/global.js');
  require('./common/season-selector.js');
  require('./common/trash-selector.js');
  require('./common/pagination-selector.js');
  require('./common/multiselect.js');
  require('./common/pusher.js');
  require('./common/link-poster.js');
  require('./common/simple-modal.js');
  require('./common/strip.js').init();
  require('./common/accessibility.js');
  require('./common/cookie-notice.js');
  require('./modules/modules.js');

  pjax.init();
  tabular();
});
